export interface AssignPermissionsToRoleDto {
  permissionIds: string[]; // Required, array of Guids
  grantedBy: string; // Required, Guid
}
